export const ADD_NOTIFICATION = 'addNotification'
export const REMOVE_NOTIFICATION = 'removeNotification'
